import Map2Gis from './Map2Gis';

export default Map2Gis;
